const DATE_SEP = '-';
const TIME_SEP = ':';

export const numFormatter = (num: number | string | undefined, showDecimal?: boolean) => {
  if (typeof num === 'undefined') {
    return '';
  } else if (typeof num === 'number') {
    const remainder = showDecimal ? (num % 1).toFixed(2).slice(1) : '';
    return num.toFixed(0).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + remainder;
  } else {
    return num.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }
};

export const dateFormatter = (date: number | string | undefined): string => {
  if (date) {
    const dateStr = date + '';
    const len = dateStr.length;
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    if (len <= 6) {
      return year + DATE_SEP + month;
    } else {
      const day = dateStr.substring(6, 8);
      if (len <= 8) {
        return year + DATE_SEP + month + DATE_SEP + day;
      } else {
        return (
          year +
          DATE_SEP +
          month +
          DATE_SEP +
          day +
          ' ' +
          dateStr.substring(8, 10) +
          TIME_SEP +
          dateStr.substring(10, 12) +
          TIME_SEP +
          dateStr.substring(12, 14)
        );
      }
    }
  } else {
    return '無日期資訊';
  }
};

/**
 * 日期轉字串 yyyyMMdd(自訂間隔)
 */
export const formateDate = (date?: Date | null, interval?: string) => {
  let result;

  if (date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    if (interval) {
      result = `${year}${interval}${padZero(month)}${interval}${padZero(day)}`;
    } else {
      result = `${year}${padZero(month)}${padZero(day)}`;
    }
  }

  return result;
};

/**
 * 字串轉日期(字串格式yyyy-MM-dd or yyyy/MM/dd or yyyyMMdd)
 */
export const stringToDate = (date: any) => {
  const needChangeSep = '/';
  const changeTo = '-';
  // 僅'-'可轉日期，故若有'/'則轉為'-'
  if (typeof date === 'string' && date.includes(needChangeSep)) {
    date = date.replaceAll(needChangeSep, changeTo);
  } else if (typeof date === 'string' && !date.includes(changeTo)) {
    date = date.substring(0, 4) + changeTo + date.substring(4, 6) + changeTo + date.substring(6, 8);
  }
  const regex = /(\d{4})-(\d{2})-(\d{2})/;
  return date && regex.test(date) ? new Date(date) : null;
};

/**
 * Pad leading zero for 2 digit number
 */
const padZero = (num: number | string) => {
  let result;

  if (typeof num === 'number') {
    result = num < 10 ? `0${num}` : `${num}`;
  } else {
    result = num.length < 2 ? `0${num}` : `${num}`;
  }

  return result;
};

/** 嘗試轉數字 */
export const tryParseInt = (value: any) => {
  const result = parseInt(value);
  return isNaN(result) ? value : result;
};
